import React, { useCallback, useMemo, useContext, useEffect, useState } from 'react';
import PageWrapper from '../../../../layout/PageWrapper/PageWrapper';
import SubHeader, { SubHeaderLeft } from '../../../../layout/SubHeader/SubHeader';
import Page from '../../../../layout/Page/Page';
import Breadcrumb from '../../../../components/bootstrap/Breadcrumb';
import { demoPages } from '../../../../menu';
import { DefaultContext } from '../../../../contexts/default';
import Card, { CardBody } from '../../../../components/bootstrap/Card';
import Button from '../../../../components/bootstrap/Button';
import TableCustom from '../../../../components/MyCustom/TableCustom';
import SelectEstablishment from '../../../../components/MyCustom/SelectEstablishment';
import SelectStore from '../../../../components/MyCustom/SelectStore';
import ModalRegisterStockProducts from '../../../../components/modals/StockProducts/ModalRegister'
import ProductDB from '../../../../database/wrappers/product';
import useDarkMode from '../../../../hooks/useDarkMode';
import StockProductDB from '../../../../database/wrappers/stockProduct';
import { orderBy } from 'firebase/firestore';
import logo from '../../../../assets/img/logo_uget_black.png'

const StockProducts = () => {
  const { darkModeStatus } = useDarkMode();

  const { establishment, store, onShowAlert } = useContext(DefaultContext)
  const [products, setProducts] = useState(null)
  const [stockProductsDicionary, setstockProductsDicionary] = useState(null)
  const [productsRender, setProductsRender] = useState([])
  const [productSelected, setProductSelected] = useState(null);
  const [showModal, setshowModal] = useState(false);

  useEffect(() => {
    if (!establishment) return;
    const onSubscribe = new ProductDB(establishment.id).on(setProducts, orderBy('name', 'asc'));
    return onSubscribe
  }, [establishment])

  useEffect(() => {
    if (!establishment || !store) return;
    const onSubscribe = new StockProductDB(establishment.id, store.id).on(datas => {
      const dicionary = {};
      datas.forEach(data => dicionary[data.id] = data)
      setstockProductsDicionary(dicionary)
    });
    return onSubscribe;
  }, [establishment, store])

  useEffect(() => {
    if (products !== null && stockProductsDicionary !== null) {
      const productsRender = products.map(product => {
        const stock = stockProductsDicionary[product.id];
        return {
          ...product,
          ...stock,
          active: !stock ? true : stock.active,
          stockExist: !!stock,
        }
      })

      setProductsRender(productsRender);
    }
  }, [products, stockProductsDicionary])

  const handleOpenModalEdit = useCallback((item) => {
    setProductSelected(item)
    setshowModal(true)
  }, [])

  const handleChangeStatus = useCallback((id, item) => {
    const onSuccess = () => { };
    const onError = () => {
      onShowAlert({
        title: 'ERRO!',
        msm: 'Não foi possível atualizar o status do produto',
        icon: 'Error',
        color: 'danger'
      })
    };
    if (item.stockExist) {
      new StockProductDB(establishment.id, store.id)
        .update(item.id, {
          active: !item.active
        })
        .then(onSuccess)
        .catch(onError)
    } else {
      new StockProductDB(establishment.id, store.id)
        .define(item.id, {
          active: !item.active
        })
        .then(onSuccess)
        .catch(onError)
    }
  }, [establishment, store])

  const columns = useMemo(() => ([
    {
      label: 'Imagem',
      field: 'image_url',
      format: row => (
        <>
          {row.image_url ? (
            <img src={row.image_url} alt="Imagem" width={54} height={54} />
          ) : (
            <img src={logo} alt="Imagem" width={60} height='auto' />
          )}
        </>
      ),
      noExport: true
    },
    {
      label: 'Nome',
      field: 'name',
    },
    {
      label: 'QTD',
      field: 'qtd',
    },
    // {
    //   label: 'Status',
    //   field: 'status',
    //   format: row => (
    //     <>
    //       <Button
    //         isLink
    //         color={row.active ? 'success' : 'danger'}
    //         icon='Circle'
    //         onClick={() => handleChangeStatus(row.id, row)}
    //         className='text-nowrap'>
    //         {row.active ? 'Ativo' : 'Inativo'}
    //       </Button>
    //     </>
    //   )
    // },
    {
      label: 'Ações',
      field: 'actions',
      format: row => (
        <div className='w-50 d-flex justify-content-between'>
          <Button
            color={darkModeStatus ? 'light' : 'dark'}
            icon="edit"
            hoverShadow="md"
            size="sm"
            text=''
            onClick={() => handleOpenModalEdit(row)}
          />
        </div>
      ),
      noExport: true,
    },
  ]), [handleChangeStatus, handleOpenModalEdit])

  return (
    <>
      <PageWrapper title={demoPages.pdvLoja.subMenu.stockProducts.text}>
        <SubHeader>
          <SubHeaderLeft>
            <Breadcrumb
              list={[
                { title: 'PDV Loja', to: '/pdvLoja/stockProducts' },
                { title: 'Estoque Produtos', to: '/pdvLoja/stockProducts' },
              ]}
            />
          </SubHeaderLeft>
        </SubHeader>
        <Page container='fluid'>
          <Card>
            <CardBody className='table-responsive p-5'>
              <div className='row d-flex align-items-center mt-4 mx-1' >
                <SelectEstablishment />
                <SelectStore />
              </div>
              <TableCustom columns={columns} rows={productsRender} fileName={'Estoque-produtos'} />
            </CardBody>
          </Card>
        </Page>
      </PageWrapper>

      <ModalRegisterStockProducts
        open={showModal}
        setIsOpen={setshowModal}
        setIsClose={() => setshowModal(false)}
        stockSelected={productSelected}
      />
    </>
  );
};

export default StockProducts;
